// extracted by mini-css-extract-plugin
export default {"body":"root_body__KPsIV"};